"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = require("../..");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _SourceTypeIcon = require("./SourceTypeIcon.styled");
var _typeIcons;
var SourceTypeIcon = function SourceTypeIcon(_ref) {
  var source = _ref.source,
    status = _ref.status,
    isStaged = _ref.isStaged,
    live = _ref.live;
  var _getIcon = getIcon(source.type),
    icon = _getIcon.icon;
  var color = status ? '#8D91AF' : live ? '#FFFFFF' : isStaged ? '#33373D' : '#FFFFFF';
  return _react["default"].createElement(_SourceTypeIcon.IconWrapper, null, _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: icon,
    color: color
  }));
};
SourceTypeIcon.propTypes = {
  source: _propTypes["default"].object.isRequired,
  status: _propTypes["default"].bool,
  isStaged: _propTypes["default"].bool,
  live: _propTypes["default"].bool
};
var _default = exports["default"] = SourceTypeIcon;
var typeIcons = (_typeIcons = {}, (0, _defineProperty2["default"])(_typeIcons, _.VIDEO_FILE, {
  icon: _freeSolidSvgIcons.faFileVideo
}), (0, _defineProperty2["default"])(_typeIcons, _.AUDIO_FILE, {
  icon: _freeSolidSvgIcons.faFileAudio
}), (0, _defineProperty2["default"])(_typeIcons, _.IMAGE_FILE, {
  icon: _freeSolidSvgIcons.faFileImage
}), (0, _defineProperty2["default"])(_typeIcons, _.PDF_FILE, {
  icon: _freeSolidSvgIcons.faFilePdf
}), (0, _defineProperty2["default"])(_typeIcons, _.CAMERA_PRESENTER, {
  icon: _freeSolidSvgIcons.faVideo
}), (0, _defineProperty2["default"])(_typeIcons, _.SCREEN_PRESENTER, {
  icon: _freeSolidSvgIcons.faTv
}), (0, _defineProperty2["default"])(_typeIcons, _.MEDIA, {
  icon: _freeSolidSvgIcons.faFileImage
}), _typeIcons);
function getIcon(type) {
  return typeIcons[type] || {
    icon: _freeSolidSvgIcons.faQuestion,
    color: '#000'
  };
}